import { render, staticRenderFns } from "./restore-assignment-modal.vue?vue&type=template&id=af826cb2"
import script from "./restore-assignment-modal.vue?vue&type=script&lang=js"
export * from "./restore-assignment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports